import { client } from "@/config/client"

interface CreateSessionData {
  subthemeId: string
}

export function createSession(data: CreateSessionData) {
  return client.post<void, CreateSessionData>("/v1/diagnoses/session", data)
}
